export const resourcesCurrency = [
  {
    id: "1",
    resourceCode: "AED",
    resourceId: "784",
    resourceName: "United Arab Emirates dirham",
    resourceSymbol: "د.إ"
  },
  {
    id: "2",
    resourceCode: "AFN",
    resourceId: "971",
    resourceName: "Afghan afghani",
    resourceSymbol: "؋"
  },
  {
    id: "3",
    resourceCode: "ALL",
    resourceId: "008",
    resourceName: "Albanian lek",
    resourceSymbol: "Lek"
  },
  {
    id: "4",
    resourceCode: "AMD",
    resourceId: "051",
    resourceName: "Armenian dram",
    resourceSymbol: "֏"
  },
  {
    id: "5",
    resourceCode: "ANG",
    resourceId: "532",
    resourceName: "Netherlands Antillean guilder",
    resourceSymbol: "ƒ"
  },
  {
    id: "6",
    resourceCode: "AOA",
    resourceId: "973",
    resourceName: "Angolan kwanza",
    resourceSymbol: "Kz"
  },
  {
    id: "7",
    resourceCode: "ARS",
    resourceId: "032",
    resourceName: "Argentine peso",
    resourceSymbol: "$"
  },
  {
    id: "8",
    resourceCode: "AUD",
    resourceId: "036",
    resourceName: "Australian dollar",
    resourceSymbol: "$"
  },
  {
    id: "9",
    resourceCode: "AWG",
    resourceId: "533",
    resourceName: "Aruban florin",
    resourceSymbol: "ƒ"
  },
  {
    id: "10",
    resourceCode: "AZN",
    resourceId: "944",
    resourceName: "Azerbaijani manat",
    resourceSymbol: "₼"
  },
  {
    id: "11",
    resourceCode: "BAM",
    resourceId: "977",
    resourceName: "Bosnia and Herzegovina convertible mark",
    resourceSymbol: "KM"
  },
  {
    id: "12",
    resourceCode: "BBD",
    resourceId: "052",
    resourceName: "Barbados dollar",
    resourceSymbol: "$"
  },
  {
    id: "13",
    resourceCode: "BDT",
    resourceId: "050",
    resourceName: "Bangladeshi taka",
    resourceSymbol: "৳"
  },
  {
    id: "14",
    resourceCode: "BGN",
    resourceId: "975",
    resourceName: "Bulgarian lev",
    resourceSymbol: "лв"
  },
  {
    id: "15",
    resourceCode: "BHD",
    resourceId: "048",
    resourceName: "Bahraini dinar",
    resourceSymbol: ".د.ب"
  },
  {
    id: "16",
    resourceCode: "BIF",
    resourceId: "108",
    resourceName: "Burundian franc",
    resourceSymbol: "FBu"
  },
  {
    id: "17",
    resourceCode: "BMD",
    resourceId: "060",
    resourceName: "Bermudian dollar",
    resourceSymbol: "$"
  },
  {
    id: "18",
    resourceCode: "BND",
    resourceId: "096",
    resourceName: "Brunei dollar",
    resourceSymbol: "$"
  },
  {
    id: "19",
    resourceCode: "BOB",
    resourceId: "068",
    resourceName: "Boliviano",
    resourceSymbol: "$b"
  },
  {
    id: "20",
    resourceCode: "BOV",
    resourceId: "984",
    resourceName: "Bolivian Mvdol (funds code)",
    resourceSymbol: "Bov"
  },
  {
    id: "21",
    resourceCode: "BRL",
    resourceId: "986",
    resourceName: "Brazilian real",
    resourceSymbol: "R$"
  },
  {
    id: "22",
    resourceCode: "BSD",
    resourceId: "044",
    resourceName: "Bahamian dollar",
    resourceSymbol: "$"
  },
  {
    id: "23",
    resourceCode: "BTN",
    resourceId: "064",
    resourceName: "Bhutanese ngultrum",
    resourceSymbol: "Nu"
  },
  {
    id: "24",
    resourceCode: "BWP",
    resourceId: "072",
    resourceName: "Botswana pula",
    resourceSymbol: "P"
  },
  {
    id: "25",
    resourceCode: "BYN",
    resourceId: "933",
    resourceName: "Belarusian ruble",
    resourceSymbol: "Br"
  },
  {
    id: "26",
    resourceCode: "BZD",
    resourceId: "084",
    resourceName: "Belize dollar",
    resourceSymbol: "BZ$"
  },
  {
    id: "27",
    resourceCode: "CAD",
    resourceId: "124",
    resourceName: "Canadian dollar",
    resourceSymbol: "$"
  },
  {
    id: "28",
    resourceCode: "CDF",
    resourceId: "976",
    resourceName: "Congolese franc",
    resourceSymbol: "FC"
  },
  {
    id: "29",
    resourceCode: "CHE",
    resourceId: "947",
    resourceName: "WIR euro (complementary currency)",
    resourceSymbol: "CHE"
  },
  {
    id: "30",
    resourceCode: "CHF",
    resourceId: "756",
    resourceName: "Swiss franc",
    resourceSymbol: "CHF"
  },
  {
    id: "31",
    resourceCode: "CHW",
    resourceId: "948",
    resourceName: "WIR franc (complementary currency)",
    resourceSymbol: "CHW"
  },
  {
    id: "32",
    resourceCode: "CLF",
    resourceId: "990",
    resourceName: "Unidad de Fomento",
    resourceSymbol: "CLF"
  },
  {
    id: "33",
    resourceCode: "CLP",
    resourceId: "152",
    resourceName: "Chilean peso",
    resourceSymbol: "$"
  },
  {
    id: "34",
    resourceCode: "COP",
    resourceId: "170",
    resourceName: "Colombian peso",
    resourceSymbol: "$"
  },
  {
    id: "35",
    resourceCode: "COU",
    resourceId: "970",
    resourceName: "Unidad de Valor Real",
    resourceSymbol: "COU"
  },
  {
    id: "36",
    resourceCode: "CRC",
    resourceId: "188",
    resourceName: "Costa Rican colon",
    resourceSymbol: "₡"
  },
  {
    id: "37",
    resourceCode: "CUC",
    resourceId: "931",
    resourceName: "Cuban convertible peso",
    resourceSymbol: "CUC$"
  },
  {
    id: "38",
    resourceCode: "CUP",
    resourceId: "192",
    resourceName: "Cuban peso",
    resourceSymbol: "₱"
  },
  {
    id: "39",
    resourceCode: "CVE",
    resourceId: "132",
    resourceName: "Cape Verdean escudo",
    resourceSymbol: "Esc"
  },
  {
    id: "40",
    resourceCode: "CZK",
    resourceId: "203",
    resourceName: "Czech koruna",
    resourceSymbol: "Kč"
  },
  {
    id: "41",
    resourceCode: "DJF",
    resourceId: "262",
    resourceName: "Djiboutian franc",
    resourceSymbol: "Fdj"
  },
  {
    id: "42",
    resourceCode: "DKK",
    resourceId: "208",
    resourceName: "Danish krone",
    resourceSymbol: "Kr"
  },
  {
    id: "43",
    resourceCode: "DOP",
    resourceId: "214",
    resourceName: "Dominican peso",
    resourceSymbol: "RD$"
  },
  {
    id: "44",
    resourceCode: "DZD",
    resourceId: "012",
    resourceName: "Algerian dinar",
    resourceSymbol: "دج"
  },
  {
    id: "45",
    resourceCode: "EGP",
    resourceId: "818",
    resourceName: "Egyptian pound",
    resourceSymbol: "E£"
  },
  {
    id: "46",
    resourceCode: "ERN",
    resourceId: "232",
    resourceName: "Eritrean nakfa",
    resourceSymbol: "Nfk"
  },
  {
    id: "47",
    resourceCode: "ETB",
    resourceId: "230",
    resourceName: "Ethiopian birr",
    resourceSymbol: "Br"
  },
  {
    id: "48",
    resourceCode: "EUR",
    resourceId: "978",
    resourceName: "Euro",
    resourceSymbol: "€"
  },
  {
    id: "49",
    resourceCode: "FJD",
    resourceId: "242",
    resourceName: "Fiji dollar",
    resourceSymbol: "$"
  },
  {
    id: "50",
    resourceCode: "FKP",
    resourceId: "238",
    resourceName: "Falkland Islands pound",
    resourceSymbol: "£"
  },
  {
    id: "51",
    resourceCode: "GBP",
    resourceId: "826",
    resourceName: "Pound sterling",
    resourceSymbol: "£"
  },
  {
    id: "52",
    resourceCode: "GEL",
    resourceId: "981",
    resourceName: "Georgian lari",
    resourceSymbol: "ლ"
  },
  {
    id: "53",
    resourceCode: "GHS",
    resourceId: "936",
    resourceName: "Ghanaian cedi",
    resourceSymbol: "GH₵"
  },
  {
    id: "54",
    resourceCode: "GIP",
    resourceId: "292",
    resourceName: "Gibraltar pound",
    resourceSymbol: "£"
  },
  {
    id: "55",
    resourceCode: "GMD",
    resourceId: "270",
    resourceName: "Gambian dalasi",
    resourceSymbol: "D"
  },
  {
    id: "56",
    resourceCode: "GNF",
    resourceId: "324",
    resourceName: "Guinean franc",
    resourceSymbol: "GFr"
  },
  {
    id: "57",
    resourceCode: "GTQ",
    resourceId: "320",
    resourceName: "Guatemalan quetzal",
    resourceSymbol: "Q"
  },
  {
    id: "58",
    resourceCode: "GYD",
    resourceId: "328",
    resourceName: "Guyanese dollar",
    resourceSymbol: "GY$"
  },
  {
    id: "59",
    resourceCode: "HKD",
    resourceId: "344",
    resourceName: "Hong Kong dollar",
    resourceSymbol: "HK$"
  },
  {
    id: "60",
    resourceCode: "HNL",
    resourceId: "340",
    resourceName: "Honduran lempira",
    resourceSymbol: "HNL"
  },
  {
    id: "61",
    resourceCode: "HRK",
    resourceId: "191",
    resourceName: "Croatian kuna",
    resourceSymbol: "Kn"
  },
  {
    id: "62",
    resourceCode: "HTG",
    resourceId: "332  ",
    resourceName: "Haitian gourde",
    resourceSymbol: "HTG"
  },
  {
    id: "63",
    resourceCode: "HUF",
    resourceId: "348",
    resourceName: "Hungarian forint",
    resourceSymbol: "Ft"
  },
  {
    id: "64",
    resourceCode: "IDR",
    resourceId: "360",
    resourceName: "Indonesian rupiah",
    resourceSymbol: "Rp"
  },
  {
    id: "65",
    resourceCode: "ILS",
    resourceId: "376",
    resourceName: "Israeli new shekel",
    resourceSymbol: "₪"
  },
  {
    id: "66",
    resourceCode: "INR",
    resourceId: "356",
    resourceName: "Indian rupee",
    resourceSymbol: "₹"
  },
  {
    id: "67",
    resourceCode: "IQD",
    resourceId: "368",
    resourceName: "Iraqi dinar",
    resourceSymbol: "ع.د"
  },
  {
    id: "68",
    resourceCode: "IRR",
    resourceId: "364",
    resourceName: "Iranian rial",
    resourceSymbol: "﷼"
  },
  {
    id: "69",
    resourceCode: "ISK",
    resourceId: "352",
    resourceName: "Icelandic króna",
    resourceSymbol: "Kr"
  },
  {
    id: "70",
    resourceCode: "JMD",
    resourceId: "388",
    resourceName: "Jamaican dollar",
    resourceSymbol: "$"
  },
  {
    id: "71",
    resourceCode: "JOD",
    resourceId: "400",
    resourceName: "Jordanian dinar",
    resourceSymbol: "د.ا"
  },
  {
    id: "72",
    resourceCode: "JPY",
    resourceId: "392",
    resourceName: "Japanese yen",
    resourceSymbol: "¥"
  },
  {
    id: "73",
    resourceCode: "KES",
    resourceId: "404",
    resourceName: "Kenyan shilling",
    resourceSymbol: "Ksh"
  },
  {
    id: "74",
    resourceCode: "KGS",
    resourceId: "417",
    resourceName: "Kyrgyzstani som",
    resourceSymbol: "Лв"
  },
  {
    id: "75",
    resourceCode: "KHR",
    resourceId: "116",
    resourceName: "Cambodian riel",
    resourceSymbol: "៛"
  },
  {
    id: "76",
    resourceCode: "KMF",
    resourceId: "174",
    resourceName: "Comoro franc",
    resourceSymbol: "CF"
  },
  {
    id: "77",
    resourceCode: "KPW",
    resourceId: "408",
    resourceName: "North Korean won",
    resourceSymbol: "₩"
  },
  {
    id: "78",
    resourceCode: "KRW",
    resourceId: "410",
    resourceName: "South Korean won",
    resourceSymbol: "₩"
  },
  {
    id: "79",
    resourceCode: "KWD",
    resourceId: "414",
    resourceName: "Kuwaiti dinar",
    resourceSymbol: "د.ك "
  },
  {
    id: "80",
    resourceCode: "KYD",
    resourceId: "136",
    resourceName: "Cayman Islands dollar",
    resourceSymbol: "CI$"
  },
  {
    id: "81",
    resourceCode: "KZT",
    resourceId: "398",
    resourceName: "Kazakhstani tenge",
    resourceSymbol: "₸"
  },
  {
    id: "82",
    resourceCode: "LAK",
    resourceId: "418",
    resourceName: "Lao kip",
    resourceSymbol: "₭"
  },
  {
    id: "83",
    resourceCode: "LBP",
    resourceId: "422",
    resourceName: "Lebanese pound",
    resourceSymbol: "ل.ل."
  },
  {
    id: "84",
    resourceCode: "LKR",
    resourceId: "144",
    resourceName: "Sri Lankan rupee",
    resourceSymbol: "Re"
  },
  {
    id: "85",
    resourceCode: "LRD",
    resourceId: "430",
    resourceName: "Liberian dollar",
    resourceSymbol: "L$"
  },
  {
    id: "86",
    resourceCode: "LSL",
    resourceId: "426",
    resourceName: "Lesotho loti",
    resourceSymbol: "L"
  },
  {
    id: "87",
    resourceCode: "LYD",
    resourceId: "434",
    resourceName: "Libyan dinar",
    resourceSymbol: "ل.د"
  },
  {
    id: "88",
    resourceCode: "MAD",
    resourceId: "504",
    resourceName: "Moroccan dirham",
    resourceSymbol: "MAD"
  },
  {
    id: "89",
    resourceCode: "MDL",
    resourceId: "498",
    resourceName: "Moldovan leu",
    resourceSymbol: "L"
  },
  {
    id: "90",
    resourceCode: "MGA",
    resourceId: "969",
    resourceName: "Malagasy ariary",
    resourceSymbol: "Ar"
  },
  {
    id: "91",
    resourceCode: "MKD",
    resourceId: "807",
    resourceName: "Macedonian denar",
    resourceSymbol: "Ден"
  },
  {
    id: "92",
    resourceCode: "MMK",
    resourceId: "104",
    resourceName: "Myanmar kyat",
    resourceSymbol: "K"
  },
  {
    id: "93",
    resourceCode: "MNT",
    resourceId: "496",
    resourceName: "Mongolian tögrög",
    resourceSymbol: "₮"
  },
  {
    id: "94",
    resourceCode: "MOP",
    resourceId: "446",
    resourceName: "Macanese pataca",
    resourceSymbol: "MOP$"
  },
  {
    id: "95",
    resourceCode: "MRU",
    resourceId: "929",
    resourceName: "Mauritanian ouguiya",
    resourceSymbol: "UM"
  },
  {
    id: "96",
    resourceCode: "MUR",
    resourceId: "480",
    resourceName: "Mauritian rupee",
    resourceSymbol: "Rs"
  },
  {
    id: "97",
    resourceCode: "MVR",
    resourceId: "462",
    resourceName: "Maldivian rufiyaa",
    resourceSymbol: "Ra"
  },
  {
    id: "98",
    resourceCode: "MWK",
    resourceId: "454",
    resourceName: "Malawian kwacha",
    resourceSymbol: "MK"
  },
  {
    id: "99",
    resourceCode: "MXN",
    resourceId: "484",
    resourceName: "Mexican peso",
    resourceSymbol: "$"
  },
  {
    id: "100",
    resourceCode: "MXV",
    resourceId: "979",
    resourceName: "Mexican Unidad de Inversion",
    resourceSymbol: "MXV"
  },
  {
    id: "101",
    resourceCode: "MYR",
    resourceId: "458",
    resourceName: "Malaysian ringgit",
    resourceSymbol: "RM"
  },
  {
    id: "102",
    resourceCode: "MZN",
    resourceId: "943",
    resourceName: "Mozambican metical",
    resourceSymbol: "MT"
  },
  {
    id: "103",
    resourceCode: "NAD",
    resourceId: "516",
    resourceName: "Namibian dollar",
    resourceSymbol: "N$"
  },
  {
    id: "104",
    resourceCode: "NGN",
    resourceId: "566",
    resourceName: "Nigerian naira",
    resourceSymbol: "₦"
  },
  {
    id: "105",
    resourceCode: "NIO",
    resourceId: "558",
    resourceName: "Nicaraguan córdoba",
    resourceSymbol: "C$"
  },
  {
    id: "106",
    resourceCode: "NOK",
    resourceId: "578",
    resourceName: "Norwegian krone",
    resourceSymbol: "Kr"
  },
  {
    id: "107",
    resourceCode: "NPR",
    resourceId: "524",
    resourceName: "Nepalese rupee",
    resourceSymbol: "रु"
  },
  {
    id: "108",
    resourceCode: "NZD",
    resourceId: "554",
    resourceName: "New Zealand dollar",
    resourceSymbol: "$"
  },
  {
    id: "109",
    resourceCode: "OMR",
    resourceId: "512",
    resourceName: "Omani rial",
    resourceSymbol: "ر.ع."
  },
  {
    id: "110",
    resourceCode: "PAB",
    resourceId: "590",
    resourceName: "Panamanian balboa",
    resourceSymbol: "B/"
  },
  {
    id: "111",
    resourceCode: "PEN",
    resourceId: "604",
    resourceName: "Peruvian sol",
    resourceSymbol: "S/"
  },
  {
    id: "112",
    resourceCode: "PGK",
    resourceId: "598",
    resourceName: "Papua New Guinean kina",
    resourceSymbol: "K"
  },
  {
    id: "113",
    resourceCode: "PHP",
    resourceId: "608",
    resourceName: "Philippine peso",
    resourceSymbol: "₱"
  },
  {
    id: "114",
    resourceCode: "PKR",
    resourceId: "586",
    resourceName: "Pakistani rupee",
    resourceSymbol: "Rs"
  },
  {
    id: "115",
    resourceCode: "PLN",
    resourceId: "985",
    resourceName: "Polish złoty",
    resourceSymbol: "zł"
  },
  {
    id: "116",
    resourceCode: "PYG",
    resourceId: "600",
    resourceName: "Paraguayan guaraní",
    resourceSymbol: "₲"
  },
  {
    id: "117",
    resourceCode: "QAR",
    resourceId: "634",
    resourceName: "Qatari riyal",
    resourceSymbol: "ر.ق"
  },
  {
    id: "118",
    resourceCode: "RON",
    resourceId: "946",
    resourceName: "Romanian leu",
    resourceSymbol: "lei"
  },
  {
    id: "119",
    resourceCode: "RSD",
    resourceId: "941",
    resourceName: "Serbian dinar",
    resourceSymbol: "din"
  },
  {
    id: "120",
    resourceCode: "CNY",
    resourceId: "156",
    resourceName: "Renminbi",
    resourceSymbol: "¥"
  },
  {
    id: "121",
    resourceCode: "RUB",
    resourceId: "643",
    resourceName: "Russian ruble",
    resourceSymbol: "₽"
  },
  {
    id: "122",
    resourceCode: "RWF",
    resourceId: "646",
    resourceName: "Rwandan franc",
    resourceSymbol: "FRw"
  },
  {
    id: "123",
    resourceCode: "SAR",
    resourceId: "682",
    resourceName: "Saudi riyal",
    resourceSymbol: "ر.س"
  },
  {
    id: "124",
    resourceCode: "SBD",
    resourceId: "090",
    resourceName: "Solomon Islands dollar",
    resourceSymbol: "Si$"
  },
  {
    id: "125",
    resourceCode: "SCR",
    resourceId: "690",
    resourceName: "Seychelles rupee",
    resourceSymbol: "Re"
  },
  {
    id: "126",
    resourceCode: "SDG",
    resourceId: "938",
    resourceName: "Sudanese pound",
    resourceSymbol: "ج.س."
  },
  {
    id: "127",
    resourceCode: "SEK",
    resourceId: "752",
    resourceName: "Swedish krona",
    resourceSymbol: "Kr"
  },
  {
    id: "128",
    resourceCode: "SGD",
    resourceId: "702",
    resourceName: "Singapore dollar",
    resourceSymbol: "S$"
  },
  {
    id: "129",
    resourceCode: "SHP",
    resourceId: "654",
    resourceName: "Saint Helena pound",
    resourceSymbol: "£"
  },
  {
    id: "130",
    resourceCode: "SLE",
    resourceId: "925",
    resourceName: "Sierra Leonean leone",
    resourceSymbol: "Le"
  },
  {
    id: "131",
    resourceCode: "SOS",
    resourceId: "706",
    resourceName: "Somali shilling",
    resourceSymbol: "Sh.so."
  },
  {
    id: "132",
    resourceCode: "SRD",
    resourceId: "968",
    resourceName: "Surinamese dollar",
    resourceSymbol: "$"
  },
  {
    id: "133",
    resourceCode: "SSP",
    resourceId: "728",
    resourceName: "South Sudanese pound",
    resourceSymbol: "£"
  },
  {
    id: "134",
    resourceCode: "STN",
    resourceId: "930",
    resourceName: "São Tomé and Príncipe dobra",
    resourceSymbol: "Db"
  },
  {
    id: "135",
    resourceCode: "SVC",
    resourceId: "222",
    resourceName: "Salvadoran colón",
    resourceSymbol: "SVC"
  },
  {
    id: "136",
    resourceCode: "SYP",
    resourceId: "760",
    resourceName: "Syrian pound",
    resourceSymbol: "£S"
  },
  {
    id: "137",
    resourceCode: "SZL",
    resourceId: "748",
    resourceName: "Swazi lilangeni",
    resourceSymbol: "L"
  },
  {
    id: "138",
    resourceCode: "THB",
    resourceId: "764",
    resourceName: "Thai baht",
    resourceSymbol: "฿"
  },
  {
    id: "139",
    resourceCode: "TJS",
    resourceId: "972",
    resourceName: "Tajikistani somoni",
    resourceSymbol: "SM"
  },
  {
    id: "140",
    resourceCode: "TMT",
    resourceId: "934",
    resourceName: "Turkmenistan manat",
    resourceSymbol: "T"
  },
  {
    id: "141",
    resourceCode: "TND",
    resourceId: "788",
    resourceName: "Tunisian dinar",
    resourceSymbol: "د.ت"
  },
  {
    id: "142",
    resourceCode: "TOP",
    resourceId: "776",
    resourceName: "Tongan paʻanga",
    resourceSymbol: "T$"
  },
  {
    id: "143",
    resourceCode: "TRY",
    resourceId: "949",
    resourceName: "Turkish lira",
    resourceSymbol: "₺"
  },
  {
    id: "144",
    resourceCode: "TTD",
    resourceId: "780",
    resourceName: "Trinidad and Tobago dollar",
    resourceSymbol: "TT$"
  },
  {
    id: "145",
    resourceCode: "TWD",
    resourceId: "901",
    resourceName: "New Taiwan dollar",
    resourceSymbol: "NT$"
  },
  {
    id: "146",
    resourceCode: "TZS",
    resourceId: "834",
    resourceName: "Tanzanian shilling",
    resourceSymbol: "TSh"
  },
  {
    id: "147",
    resourceCode: "UAH",
    resourceId: "980",
    resourceName: "Ukrainian hryvnia",
    resourceSymbol: "₴"
  },
  {
    id: "148",
    resourceCode: "UGX",
    resourceId: "800",
    resourceName: "Ugandan shilling",
    resourceSymbol: "USh"
  },
  {
    id: "149",
    resourceCode: "USD",
    resourceId: "840",
    resourceName: "United States dollar",
    resourceSymbol: "$"
  },
  {
    id: "150",
    resourceCode: "UYU",
    resourceId: "858",
    resourceName: "Uruguayan peso",
    resourceSymbol: "$U"
  },
  {
    id: "151",
    resourceCode: "UZS",
    resourceId: "860",
    resourceName: "Uzbekistan sum",
    resourceSymbol: "UZS"
  },
  {
    id: "152",
    resourceCode: "VED",
    resourceId: "926",
    resourceName: "Venezuelan digital bolívar",
    resourceSymbol: "VED"
  },
  {
    id: "153",
    resourceCode: "VES",
    resourceId: "928",
    resourceName: "Venezuelan sovereign bolívar",
    resourceSymbol: "VES"
  },
  {
    id: "154",
    resourceCode: "VND",
    resourceId: "704",
    resourceName: "Vietnamese đồng",
    resourceSymbol: "₫"
  },
  {
    id: "155",
    resourceCode: "VUV",
    resourceId: "548",
    resourceName: "Vanuatu vatu",
    resourceSymbol: "VT"
  },
  {
    id: "156",
    resourceCode: "WST",
    resourceId: "882",
    resourceName: "Samoan tala",
    resourceSymbol: "$"
  },
  {
    id: "157",
    resourceCode: "XAF",
    resourceId: "950",
    resourceName: "CFA franc BEAC",
    resourceSymbol: "FCFA"
  },
  {
    id: "158",
    resourceCode: "XCD",
    resourceId: "951",
    resourceName: "East Caribbean dollar",
    resourceSymbol: "$"
  },
  {
    id: "159",
    resourceCode: "XDR",
    resourceId: "960",
    resourceName: "Special drawing rights",
    resourceSymbol: "XDR"
  },
  {
    id: "160",
    resourceCode: "XOF",
    resourceId: "952",
    resourceName: "CFA franc BCEAO",
    resourceSymbol: "CFA"
  },
  {
    id: "161",
    resourceCode: "XPF",
    resourceId: "953",
    resourceName: "CFP franc",
    resourceSymbol: "₣"
  },
  {
    id: "162",
    resourceCode: "XSU",
    resourceId: "994",
    resourceName: "SUCRE",
    resourceSymbol: "S/."
  },
  {
    id: "163",
    resourceCode: "XUA",
    resourceId: "965",
    resourceName: "ADB Unit of Account",
    resourceSymbol: "XUA"
  },
  {
    id: "164",
    resourceCode: "YER",
    resourceId: "886",
    resourceName: "Yemeni rial",
    resourceSymbol: "﷼"
  },
  {
    id: "165",
    resourceCode: "ZAR",
    resourceId: "710",
    resourceName: "South African rand",
    resourceSymbol: "R"
  },
  {
    id: "166",
    resourceCode: "ZMW",
    resourceId: "967",
    resourceName: "Zambian kwacha",
    resourceSymbol: "ZK"
  },
  {
    id: "167",
    resourceCode: "ZWL",
    resourceId: "932",
    resourceName: "Zimbabwean dollar",
    resourceSymbol: "Z$"
  },
];